export default "__VITE_ASSET__4fa62ae3__"